(function() {
  'use strict';

  var config = window.__srnConfig || {};
  if (!config.clientId || !config.onetapUrl) return;

  var u = window.__srnUtils;
  if (!u) return;

  var visitorId = u.getCookie('srn_vid') || crypto.randomUUID();

  // Fire-and-forget funnel tracking. Reuses the site beacon endpoint.
  // Wrapped so a tracking failure can never break the sign-in/consent flow.
  function track(name, meta) {
    try {
      var url = config.beaconUrl;
      if (!url) return;
      var payload = JSON.stringify({ events: [{
        event: name,
        visitor_id: visitorId,
        session_id: sessionStorage.getItem('srn_sid') || visitorId,
        page_url: window.location.href.slice(0, 2000),
        metadata: meta || {}
      }]});
      if (navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));
      } else {
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true }).catch(function() {});
      }
    } catch (e) {}
  }

  function shouldSkip() {
    if (u.getCookie('srn_email')) return true;
    if (window.__srnCustomer) return true;
    if (u.getCookie('srn_onetap_dismissed')) return true;
    return false;
  }

  function handleCredential(response) {
    var credential = response.credential;
    track('onetap_signin'); // user selected a Google account

    function post(phase) {
      return fetch(config.onetapUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phase: phase,
          credential: credential,
          visitor_id: visitorId,
          page_url: window.location.href,
          country: config.country || undefined
        })
      }).then(function(r) { return r.json(); });
    }

    // Phase A: identify only (no marketing subscribe).
    post('identify').then(function(data) {
      if (!data) return;
      var name = data.firstName || '';
      var toast = window.__srnToast;
      if (!toast) return;

      if (data.promptType === 'claim_with_code' || data.promptType === 'claim_no_code') {
        var withCode = data.promptType === 'claim_with_code';
        track('onetap_offer_shown', { prompt_type: data.promptType });
        // Soft cooldown: if they see the offer and neither claim nor dismiss it, don't
        // re-prompt on every page load. Explicit dismiss (onDismiss) extends this to 7d.
        u.setCookie('srn_onetap_dismissed', '1', 1);
        toast.prompt({
          msg: (name ? 'Welcome, ' + name + '. ' : 'Welcome. ')
            + (withCode ? 'Claim 5% off your first order and join our list.'
                        : 'Join our list for new arrivals and offers.'),
          notice: 'You agree to receive Sarron marketing emails. Unsubscribe anytime.',
          buttonText: withCode ? 'Claim 5% & join' : 'Join the list',
          onClaim: function() {
            track('onetap_claim', { prompt_type: data.promptType });
            // Phase B: the click is the consent act. Subscribe happens server-side in Shopify.
            return post('consent').then(function(res) {
              if (res && res.ok) {
                if (data.email) u.setCookie('srn_email', data.email, 90);
                u.setCookie('sarron_nl_subscribed', '1', 365);
                return {
                  code: res.discountCode || null,
                  msg: res.discountCode
                    ? 'You are in! Use this code for 5% off your first order.'
                    : 'You are in. Watch your inbox for what is new.'
                };
              }
              // Race: state changed to already-subscribed/opted-out between identify and click.
              if (res && res.status === 'welcome_back') {
                if (data.email) u.setCookie('srn_email', data.email, 90);
                u.setCookie('sarron_nl_subscribed', '1', 365);
                return { code: null, msg: 'You are already on our list. Welcome back!' };
              }
              throw new Error('consent failed');
            });
          },
          onDismiss: function() {
            track('onetap_dismiss', { prompt_type: data.promptType });
            // Declined the offer: back off so we do not re-nag on every page load.
            u.setCookie('srn_onetap_dismissed', '1', 7);
          }
        });
      } else {
        // welcome_back: already subscribed or opted out. No prompt, no code.
        track('onetap_welcome_back');
        if (data.email) u.setCookie('srn_email', data.email, 90);
        u.setCookie('sarron_nl_subscribed', '1', 365);
        toast.show('Welcome back' + (name ? ', ' + name : '') + '!', null, 5000);
      }
    }).catch(function(err) {
      console.error('One Tap error:', err);
    });
  }

  function initOneTap() {
    google.accounts.id.initialize({
      client_id: config.clientId,
      callback: handleCredential,
      auto_select: true,
      cancel_on_tap_outside: true
    });

    google.accounts.id.prompt(function(notification) {
      // All notification predicate calls are guarded together: a GIS variant missing
      // one of these must not throw uncaught (which would skip the cooldown -> re-nag).
      try {
        var skipped = notification.isSkippedMoment && notification.isSkippedMoment();
        var dismissed = notification.isDismissedMoment && notification.isDismissedMoment();
        if (notification.isNotDisplayed && notification.isNotDisplayed()) {
          track('onetap_prompt', { state: 'not_displayed', reason: notification.getNotDisplayedReason && notification.getNotDisplayedReason() });
          if (!u.getCookie('srn_onetap_dismissed')) {
            try { window.dispatchEvent(new Event('sarron:onetap-fallback')); } catch (e) {}
          }
        } else if (notification.isDisplayed && notification.isDisplayed()) {
          track('onetap_prompt', { state: 'displayed' });
        } else if (skipped) {
          track('onetap_prompt', { state: 'skipped', reason: notification.getSkippedReason && notification.getSkippedReason() });
        } else if (dismissed) {
          track('onetap_prompt', { state: 'dismissed', reason: notification.getDismissedReason && notification.getDismissedReason() });
        }
        if (skipped || dismissed) {
          if (dismissed && notification.getDismissedReason && notification.getDismissedReason() === 'credential_returned') return;
          u.setCookie('srn_onetap_dismissed', '1', 7);
        }
      } catch (e) {}
    });
  }

  function loadGis() {
    if (window.google && window.google.accounts) {
      initOneTap();
      return;
    }
    var script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = initOneTap;
    document.head.appendChild(script);
  }

  function start() {
    if (shouldSkip()) return;
    loadGis();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
